<template>
    <div class="languages">
        <b-dropdown right variant="">
            <template #button-content>
                <img :src="language.icon" alt="lang"/> <span class="sr-only">{{ language.label }}</span>
            </template>

            <b-dropdown-item v-for="language in languages" :key="language.id" v-if="!language.is_selected" @click="doChange(language)">
                <img :src="language.icon" alt="lang"/> {{ language.label }}</b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script type="text/babel">
    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'

    export default {
        name: 'Languages',
        computed : {
            ...mapGetters({
                language : 'language/selected',
                languages : 'language/all',
            })
        },
        methods : {
            ...mapActions({
                'doLanguageSet': 'language/set',
            }),
            doChange(language) {
                this.doLanguageSet({ lang: language.id }).then(() => {
                    // document.location.reload();
                });
            },
        },
    }
</script>